<template>
  <AdminModal title="Modo impersonación" @close="$emit('close')">
    <p class="ad-note ad-note--danger">
      Confirma tu contraseña para entrar en modo impersonación de <strong>{{ park.name }}</strong>.
      Verás el parque exactamente como su administrador y cada cambio que hagas quedará en la bitácora.
      La sesión dura 2 horas.
    </p>
    <form class="ad-field" @submit.prevent="submit">
      <label for="imp-pass">Contraseña</label>
      <input id="imp-pass" v-model="password" type="password" class="ad-input" autocomplete="current-password" autofocus />
    </form>
    <p v-if="error" class="ad-error">{{ error }}</p>
    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="$emit('close')">Cancelar</button>
      <button type="button" class="ad-btn ad-btn--danger" :disabled="busy || !password" @click="submit">
        {{ busy ? 'Entrando…' : 'Entrar como este parque' }}
      </button>
    </template>
  </AdminModal>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import AdminModal from './AdminModal.vue'
import { impersonatePark } from '@/services/superadmin'
import { useAuthStore } from '@/services/authStore'
import { errorText } from './adminFormat'

const props = defineProps({ park: { type: Object, required: true } })
defineEmits(['close'])

const router = useRouter()
const { refreshUser } = useAuthStore()
const password = ref('')
const busy = ref(false)
const error = ref('')

async function submit() {
  if (!password.value || busy.value) return
  busy.value = true
  error.value = ''
  try {
    const { redirect } = await impersonatePark(props.park.id, password.value)
    // La sesión del parque ya quedó en la cookie: se carga el usuario (con su banner) y se entra.
    await refreshUser()
    router.push(redirect || '/inicio')
  } catch (err) {
    error.value = errorText(err)
    busy.value = false
  }
}
</script>